import {ChangeDetectionStrategy, Component, EventEmitter, OnInit} from "@angular/core";
import {FormControl} from "@angular/forms";
import {Observable} from "rxjs";
import {dateEquals} from "../../../helpers";
import {distinctUntilChanged} from "rxjs/operators";
import {PopoverContext} from "../../../n-popover/public_exports";

@Component({
  selector: "n-input-calendar-popover",
  templateUrl: "n-input-calendar-popover.html",
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class NInputCalendarPopoverComponent implements OnInit {

  dateControl = new FormControl();

  maxDate: Date;
  minDate: Date;

  private date: Date;

  constructor(private ctx: PopoverContext<IInputCalendarComponentOptions>) {
    this.maxDate = ctx.popoverData.maxDate;
    this.minDate = ctx.popoverData.minDate;
  }

  ngOnInit() {

    this.dateControl
      .valueChanges
      .pipe(
        distinctUntilChanged()
      )
      .subscribe(d => {
        this.date = d;
        this.ctx.popoverData.change.emit(d);
      });

    this.ctx.popoverData.date$
      .pipe(
        distinctUntilChanged()
      )
      .subscribe(d => {
        if (!dateEquals(d, this.date)) {
          this.date = d;
          this.dateControl.setValue(d, {emitEvent: false});
        }
      });
  }
}

export interface IInputCalendarComponentOptions {
  maxDate: Date;
  minDate: Date;
  change: EventEmitter<Date>;
  date$: Observable<Date>;
}
